import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Search = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  // Automatically generate search mappings from routes
  const searchMapping = {
    // Main features
    'blog': { path: '/blog', keywords: ['blog', 'articles', 'posts'] },
    'blog generator': { path: '/blog-article-generator', keywords: ['blog writer', 'article generator', 'content writer', 'ai writer'] },
    'promotional email': { path: '/promotional-email-generator', keywords: ['email generator', 'email marketing', 'promo emails'] },
    
    // Marketing Services
    'marketing services': { path: '/marketing-services', keywords: ['services', 'marketing help'] },
    'marketing tools': { path: '/ai-marketing-tools', keywords: ['ai tools', 'marketing ai', 'automation'] },
    'marketing genius': { path: '/marketing-genius', keywords: ['ai assistant', 'marketing help', 'genius'] },
    
    // Platforms
    'paid ads': { path: '/paid-ads', keywords: ['advertising', 'ppc', 'google ads', 'facebook ads'] },
    'social media': { path: '/socials', keywords: ['social networks', 'social marketing', 'social media marketing'] },
    'websites': { path: '/websites', keywords: ['web design', 'web development'] },
    'wix': { path: '/wix', keywords: ['website builder', 'wix website'] },
    'youtube': { path: '/platforms/youtube', keywords: ['video marketing', 'youtube marketing', 'video content'] },
    'google': { path: '/platforms/google', keywords: ['google marketing', 'search marketing', 'seo'] },
    'facebook': { path: '/platforms/facebook', keywords: ['facebook marketing', 'social ads', 'meta'] },
    'shopify': { path: '/platforms/shopify_p', keywords: ['ecommerce', 'online store', 'shop'] },
    'wordpress': { path: '/platforms/wordpress', keywords: ['cms', 'website builder', 'blog platform'] },
    'more platforms': { path: '/platforms/more', keywords: ['other platforms', 'additional services'] },
    
    // Portals
    'subscriptions': { path: '/subscriptions-plans', keywords: ['pricing', 'plans', 'subscribe'] },
    'agencies': { path: '/agencies', keywords: ['agency', 'marketing agency'] },
    'content creators': { path: '/content-creators', keywords: ['creators', 'influencers'] },
    'corporate': { path: '/corporate-products', keywords: ['business', 'enterprise'] },
    
    // Other Pages
    'about us': { path: '/about-us', keywords: ['company', 'about', 'information'] },
    'contact': { path: '/contact', keywords: ['contact us', 'reach out', 'support'] },
    'videos': { path: '/videos', keywords: ['video content', 'video marketing'] },
    'pr': { path: '/pr', keywords: ['public relations', 'press', 'media'] },
  };

  useEffect(() => {
    if (searchTerm.length > 1) {
      // Enhanced search that checks both main terms and keywords
      const filteredSuggestions = Object.entries(searchMapping).filter(([term, data]) => {
        const searchLower = searchTerm.toLowerCase();
        return term.toLowerCase().includes(searchLower) || 
               data.keywords.some(keyword => keyword.toLowerCase().includes(searchLower));
      });

      // Sort results - exact matches first, then keyword matches
      const sortedSuggestions = filteredSuggestions.sort(([termA], [termB]) => {
        const aStartsWith = termA.toLowerCase().startsWith(searchTerm.toLowerCase());
        const bStartsWith = termB.toLowerCase().startsWith(searchTerm.toLowerCase());
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;
        return 0;
      });

      setSuggestions(sortedSuggestions.map(([term]) => term));
    } else {
      setSuggestions([]);
    }
  }, [searchTerm]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (suggestions.length > 0) {
      navigate(searchMapping[suggestions[0]].path);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchTerm(suggestion);
    setSuggestions([]);
    navigate(searchMapping[suggestion].path);
  };

  return (
    <div className="search-container">
      <form onSubmit={handleSearchSubmit} className="search-form">
        <input
          type="text"
          placeholder="Search tools, services, or content..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-bar"
          autoComplete="off"
        />
        <button type="submit" className="button-touch search-button-touch">
          Search
        </button>
      </form>
      {suggestions.length > 0 && (
        <div className="search-suggestions">
          {suggestions.map((suggestion, index) => (
            <div
              key={index}
              className="suggestion-item"
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Search;
